let $window = $(window);

let _getCurrentVpBottom = function() {
    return (
        (window.innerHeight ? window.innerHeight : $window.height()) +
        $window.scrollTop()
    );
};

let _getCurrentVpTop = function() {
    return $window.scrollTop();
};

let viewport = {
    isIn: function($item, vpBottom, vpTop) {
        vpBottom = vpBottom === undefined ? _getCurrentVpBottom() : vpBottom;
        vpTop = vpTop === undefined ? _getCurrentVpTop() : vpTop;

        let itemTop = $item.offset().top;
        let itemBottom = $item.offset().top + $item.height();
        return itemTop > vpTop && itemBottom < vpBottom;
    },

    isBelow: function($item, vpBottom) {
        vpBottom = vpBottom === undefined ? _getCurrentVpBottom() : vpBottom;

        let itemBottom = $item.offset().top + $item.height();
        return itemBottom > vpBottom;
    }
};

export default viewport;
